import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { fuenteI } from 'src/app/modelos/fuentes.interface';
import { PeriodoReporteI } from 'src/app/modelos/PeriodoReporte';
import { VigenciaI } from 'src/app/modelos/VigenciaReporte';
import { AlertasService } from 'src/app/servicios/alertas/alertas.service';
import { ApiService } from 'src/app/servicios/api/api.service';
import { AppServiceService } from 'src/app/servicios/AppService.service';

@Component({
  selector: 'app-calendariochv',
  templateUrl: './calendariochv.component.html',
  styleUrls: ['./calendariochv.component.css']
})
export class CalendariochvComponent implements OnDestroy, OnInit {

  @ViewChild(DataTableDirective, {static: false})
  datatableElement: DataTableDirective;

  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();

  fechaHoy: Date = new Date();

  PeriodosCalendario : PeriodoReporteI[];
  PeriodoEditar : PeriodoReporteI;

  anioMin : number;
  Anio: number;

  mensual : Boolean;
  mendis : Boolean;
  trimestral : Boolean;
  tridis :Boolean;
  //nuevoAnio : number = 0;
  //nuevoSalarioMin : number = 0;
  NuevaVigenciaRep : VigenciaI;

  nuevoAnio= new FormControl('',[Validators.required, Validators.pattern('[0-9]*')]);
  nuevoSalarioMin = new FormControl('', [
    Validators.required,
    Validators.pattern('^[0-9]*$'),
    Validators.minLength(6),
    Validators.maxLength(10),
    Validators.min(100000),
    Validators.max(9999999999)
  ]);


  PeriEdit : string;
  SalaEdit : number;
  PAdesde : string;
  PAhasta : string;
  PRdesde : string;
  PRhasta : string;
  PRSdesde : string;
  PRShasta : string;
  PPdesde : string;
  PPhasta : string;

  PermitEditPRdesde : Boolean;
  PermitEditPRhasta : Boolean;
  PermitEditPRSdesde : Boolean;
  PermitEditPRShasta : Boolean;
  btnGuardarVigencia : Boolean;

  currentYear = new Date().getFullYear();

  @ViewChild('closeModalCrearAnio') closeModalCrearAnio: ElementRef;
  @ViewChild('closeModalEditarPeriodo') closeModalEditarPeriodo: ElementRef;

  constructor(
    private api:ApiService,
    private router:Router,
    private alerta:AlertasService,
    private appService:AppServiceService,
    private toastr: ToastrService
  ) {
    const currentYear = new Date().getFullYear();
    this.Anio = currentYear + 1;
   }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      responsive: true,
      order: [],
      language:
        {
          "processing": "Procesando...",
          "lengthMenu": "Mostrar _MENU_ registros",
          "zeroRecords": "No se encontraron resultados",
          "emptyTable": "Ningún dato disponible en esta tabla",
          "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
          "infoFiltered": "(filtrado de un total de _MAX_ registros)",
          "search": "Buscar:",
          "loadingRecords": "Cargando...",
          "paginate": {
              "first": "Primero",
              "last": "Último",
              "next": "Siguiente",
              "previous": "Anterior"
          },
          "aria": {
              "sortAscending": ": Activar para ordenar la columna de manera ascendente",
              "sortDescending": ": Activar para ordenar la columna de manera descendente"
          },
          "info": "Mostrando de _START_ a _END_ de _TOTAL_ periodos"
        }
    };
    this.NuevaVigenciaRep = new VigenciaI;
    this.PermitEditPRdesde = false;
    this.PermitEditPRhasta = false;
    this.PermitEditPRSdesde = false;
    this.PermitEditPRShasta = false;
    this.mensual = false;
    this.trimestral = false;
    this.mendis = false;
    this.tridis = false;
    this.anioMin = 2016;
    this.btnGuardarVigencia = false;
    this.PeriodoEditar = new PeriodoReporteI;
    this.api.listaPeriodosCalendario().subscribe(data=>{

      const currentYearData = data.filter(item => new Date(item.fechaInicioPeriodo).getFullYear() === this.currentYear);
      const otherYearData = data.filter(item => new Date(item.fechaInicioPeriodo).getFullYear() !== this.currentYear);

      const sortedCurrentYearData = currentYearData.sort((a, b) => {
        return new Date(a.fechaInicioPeriodo).getTime() - new Date(b.fechaInicioPeriodo).getTime();
      });
      const sortedOtherYearData = otherYearData.sort((a, b) => {
        return new Date(a.fechaInicioPeriodo).getTime() - new Date(b.fechaInicioPeriodo).getTime();
      });

      this.PeriodosCalendario = [...sortedCurrentYearData, ...sortedOtherYearData];

      this.dtTrigger.next();
    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  regresarCalendario(){
    this.router.navigate(['calendario']);
  }

  consultarListaCalendario(){
    this.api.listaPeriodosCalendario().subscribe(data=>{
      this.PeriodosCalendario = data;
    });
  }

  SeleccionPeriodicidad(){
    if (this.mensual){
      this.tridis = true;
      this.trimestral = false;
    } else if (this.trimestral){
      this.mendis = true;
      this.mensual = false;
    } else if (!this.mensual && !this.trimestral){
      this.mendis = false;
      this.tridis = false;
      this.mensual = false;
      this.trimestral = false;
    }
  }

  crearVigencia(){
    this.btnGuardarVigencia = true;
    this.NuevaVigenciaRep.anio = this.nuevoAnio.value;
    this.NuevaVigenciaRep.salarioMinimo = this.nuevoSalarioMin.value;
    if (!this.mensual && !this.trimestral){
      this.btnGuardarVigencia = false;
      this.toastr.warning('Debe seleccionar periodicidad.', 'Advertencia!');
    } else if (this.nuevoAnio.hasError('required')){
      this.btnGuardarVigencia = false;
      this.toastr.warning('Debe seleccionar año.', 'Advertencia!');
    } else if (this.nuevoSalarioMin.hasError('min')){
      this.btnGuardarVigencia = false;
      this.toastr.warning('Salario mínimo debe tener al menos 6 cifras.', 'Advertencia!');
    } else if (this.nuevoSalarioMin.hasError('max')){
      this.btnGuardarVigencia = false;
      this.toastr.warning('Salario mínimo debe tener máximo 10 cifras.', 'Advertencia!');
    } else if (this.nuevoSalarioMin.hasError('required')){
      this.btnGuardarVigencia = false;
      this.toastr.warning('Debe ingresar el valor de SMMLV.', 'Advertencia!');
    } else {
      this.api.existeVigencia(this.nuevoAnio.value).subscribe(existe=>{
        if(existe){
          this.btnGuardarVigencia = false;
          this.toastr.error('Existente calendario para la vigencia seleccionada.', 'Error!');
        } else {
          this.api.nuevaVigencia(this.NuevaVigenciaRep).subscribe(nuevavig=>{
            if(nuevavig){
              if (this.trimestral){
                this.api.crearPeriodosTrimestresCHV(this.nuevoAnio.value).subscribe(period=>{
                  if (period){
                    this.closeModalCrearAnio.nativeElement.click();
                    this.toastr.success('Calendario trimestal creado.', 'OK!');
                    window.location.reload();
                  }
                });
              }
              if (this.mensual){
                this.api.crearPeriodosMensualesCHV(this.nuevoAnio.value).subscribe(period1=>{
                  if (period1){
                    this.closeModalCrearAnio.nativeElement.click();
                    this.toastr.success('Calendario mensual creado.', 'OK!');
                    window.location.reload();
                  }
                });
              }
            }
          }, error=>{
            this.btnGuardarVigencia = false;
            this.toastr.error('Error al crear calendario de reporte.', 'Error!');
          });
        }
      }, error=>{
        this.btnGuardarVigencia = false;
        this.toastr.error('Error al crear calendario de reporte.', 'Error!');
      });
    }
  }

  cancelarCrearVigencia(){
    this.mendis = false;
    this.tridis = false;
    this.mensual = false;
    this.trimestral = false;
    this.nuevoAnio.setValue("");
    this.nuevoSalarioMin.setValue("");
  }

  EditarPeriodo(periodo: PeriodoReporteI) {
    this.PermitEditPRdesde = this.verificarFecha(new Date(), this.convertirFecha(periodo.fechaInicioRecoleccion));
    this.PermitEditPRhasta = this.verificarFecha(new Date(), this.convertirFecha(periodo.fechaFinRecoleccion));
    this.PermitEditPRSdesde = this.verificarFecha(new Date(), this.convertirFecha(periodo.fechaInicioRecoleccionSuper));
    this.PermitEditPRShasta = this.verificarFecha(new Date(), this.convertirFecha(periodo.fechaFinRecoleccionSuper));

    this.PeriodoEditar = periodo;
    this.PeriEdit = `${periodo.anio} - ${periodo.consecutivoPeriodo} ${periodo.descripcionPeriodo}`;
    this.SalaEdit = periodo.salarioMinimo;
    this.PAdesde = this.formatearFecha(periodo.fechaInicioPeriodo);
    this.PAhasta = this.formatearFecha(periodo.fechaFinPeriodo);
    this.PRdesde = this.formatearFecha(periodo.fechaInicioRecoleccion);
    this.PRhasta = this.formatearFecha(periodo.fechaFinRecoleccion);
    this.PRSdesde = this.formatearFecha(periodo.fechaInicioRecoleccionSuper);
    this.PRShasta = this.formatearFecha(periodo.fechaFinRecoleccionSuper);
    this.PPdesde = this.formatearFecha(periodo.fechaInicioProcesamiento);
    this.PPhasta = this.formatearFecha(periodo.fechaFinProcesamiento);
  }

  verificarFecha(fechaActual: Date, fechaComparar: Date): boolean {
      return fechaActual > fechaComparar;
  }

  convertirFecha(fecha: string): Date {
      const [dia, mes, anio] = fecha.split("/").map(Number);
      return new Date(anio, mes - 1, dia);
  }

  formatearFecha(fecha: string): string {
      const [dia, mes, anio] = fecha.split("/");
      return `${anio}-${mes}-${dia}`;
  }

  parseDate(fecha: string): Date {
    const [day, month, year] = fecha.split('/').map(Number);
    return new Date(year, month - 1, day);
  }

  isValidDateRange(startDate: Date, endDate: Date): boolean {
    return startDate < endDate;
  }

  GuardarPeriodoEditado() {

    const fechaInicioPeriodo = this.parseDate(this.PeriodoEditar.fechaInicioPeriodo);
    const fechaFinPeriodo = this.parseDate(this.PeriodoEditar.fechaFinPeriodo);
    const fechaInicioRecoleccion = this.parseDate(this.PRdesde.split("-").reverse().join("/"));
    const fechaFinRecoleccion = this.parseDate(this.PRhasta.split("-").reverse().join("/"));
    const fechaInicioRecoleccionSuper = this.parseDate(this.PRSdesde.split("-").reverse().join("/"));
    const fechaFinRecoleccionSuper = this.parseDate(this.PRShasta.split("-").reverse().join("/"));

    if (this.SalaEdit < 100000) {
      this.toastr.warning('Salario mínimo debe tener al menos 6 cifras.', 'Advertencia!');
      return;
    } else if (this.SalaEdit > 9999999999) {
      this.toastr.warning('Salario mínimo debe tener máximo 10 cifras.', 'Advertencia!');
      return;
    }

    if (this.isValidDateRange(fechaInicioRecoleccion, this.fechaHoy)&&!this.PermitEditPRdesde) {
      this.toastr.warning('Fecha inicio recolección es igual o inferior a la actual.', 'Advertencia!');
      return;
    }else if (this.isValidDateRange(fechaInicioRecoleccionSuper, this.fechaHoy)&&!this.PermitEditPRSdesde) {
      this.toastr.warning('Fecha inicio recolección Supersolidaria es igual o inferior a la actual.', 'Advertencia!');
      return;
    }

    if (this.isValidDateRange(fechaFinRecoleccion, this.fechaHoy)&&!this.PermitEditPRhasta) {
      this.toastr.warning('Fecha fin recolección es igual o inferior a la actual.', 'Advertencia!');
      return;
    }else if (this.isValidDateRange(fechaFinRecoleccionSuper, this.fechaHoy)&&!this.PermitEditPRShasta) {
      this.toastr.warning('Fecha fin recolección Supersolidaria es igual o inferior a la actual.', 'Advertencia!');
      return;
    }

    if (!this.isValidDateRange(fechaInicioRecoleccion, fechaFinRecoleccion)) {
      this.toastr.warning('Fecha inicio recolección es igual o superior a la final.', 'Advertencia!');
      return;
    } else if (!this.isValidDateRange(fechaInicioRecoleccionSuper, fechaFinRecoleccionSuper)) {
      this.toastr.warning('Fecha inicio recolección Supersolidaria es igual o superior a la final.', 'Advertencia!');
      return;
    }

    const [anioRecoleccion, mesRecoleccion] = [fechaInicioPeriodo.getFullYear(), fechaInicioPeriodo.getMonth() + 1];
    const siguienteMes = this.obtenerSiguienteMes(anioRecoleccion, mesRecoleccion);
    const siguienteTrimestre = this.obtenerSiguienteTrimestre(anioRecoleccion, mesRecoleccion);

    const fechaInicioMesSiguiente = new Date(siguienteMes.anio, siguienteMes.mes - 1, 1);
    const fechaFinMesSiguiente = new Date(siguienteMes.anio, siguienteMes.mes, 0);

    const fechaInicioTrimestreSiguiente = new Date(siguienteTrimestre.anio, siguienteTrimestre.mesInicio - 1, 1);
    const fechaFinTrimestreSiguiente = new Date(siguienteTrimestre.anio, siguienteTrimestre.mesFin, 0);

    const esMensual = this.PeriodoEditar.tipoPeriodicidad === 'Mensual';
    const esTrimestral = this.PeriodoEditar.tipoPeriodicidad === 'Trimestral';

    if (esMensual) {
      if (fechaInicioRecoleccion < fechaInicioMesSiguiente || fechaFinRecoleccion > fechaFinMesSiguiente) {
        this.toastr.warning('Las fechas de recolección mensual deben corresponder al siguiente mes.', 'Advertencia!');
        return;
      }
      if (fechaInicioRecoleccionSuper < fechaInicioMesSiguiente || fechaFinRecoleccionSuper > fechaFinMesSiguiente) {
        this.toastr.warning('Las fechas de recolección para Supersolidaria trimestral deben corresponder al siguiente trimestre.', 'Advertencia!');
        return;
      }
    }

    if (esTrimestral) {
      if (fechaInicioRecoleccion < fechaInicioTrimestreSiguiente || fechaFinRecoleccion > fechaFinTrimestreSiguiente) {
        this.toastr.warning('Las fechas de recolección trimestral deben corresponder al siguiente trimestre.', 'Advertencia!');
        return;
      }
      if (fechaInicioRecoleccionSuper < fechaInicioTrimestreSiguiente || fechaFinRecoleccionSuper > fechaFinTrimestreSiguiente) {
        this.toastr.warning('Las fechas de recolección para Supersolidaria trimestral deben corresponder al siguiente trimestre.', 'Advertencia!');
        return;
      }
    }

    this.PeriodoEditar.salarioMinimo = this.SalaEdit;
    this.PeriodoEditar.fechaInicioRecoleccion = this.PRdesde.split("-").reverse().join("/");
    this.PeriodoEditar.fechaFinRecoleccion = this.PRhasta.split("-").reverse().join("/");
    this.PeriodoEditar.fechaInicioRecoleccionSuper = this.PRSdesde.split("-").reverse().join("/");
    this.PeriodoEditar.fechaFinRecoleccionSuper = this.PRShasta.split("-").reverse().join("/");

    this.api.editarPeriodoCHV(this.PeriodoEditar).subscribe(result => {
      if (result) {
        this.toastr.success('Periodo actualizado.', 'OK!');
        this.closeModalCrearAnio.nativeElement.click();
        window.location.reload();
      }
    }, error => {
      this.toastr.error('Error al actualizar el periodo.', 'Error!');
    });
  }

  obtenerSiguienteMes(anio: number, mes: number): { anio: number, mes: number } {
    if (mes === 12) {
      return { anio: anio + 1, mes: 1 };
    }
    return { anio, mes: mes + 1 };
  }

  obtenerSiguienteTrimestre(anio: number, mes: number): { anio: number, mesInicio: number, mesFin: number } {
    const trimestres = [
      { inicio: 1, fin: 3 },
      { inicio: 4, fin: 6 },
      { inicio: 7, fin: 9 },
      { inicio: 10, fin: 12 }
    ];
    const trimestreActual = trimestres.find(t => mes >= t.inicio && mes <= t.fin);

    if (!trimestreActual) throw new Error('Mes inválido');

    const siguienteTrimestre = trimestres[(trimestres.indexOf(trimestreActual) + 1) % 4];
    const siguienteAnio = trimestreActual.fin === 12 ? anio + 1 : anio;

    return { anio: siguienteAnio, mesInicio: siguienteTrimestre.inicio, mesFin: siguienteTrimestre.fin };
  }



}
